(exports.GAME_ID = "64134c5024ea4bdb1ee04433"),
(exports.FORM_ID = "64134c5024ea4bdb1ee04491"),
(exports.STATUS_FORM_ID = "64134c5024ea4bdb1ee044ab"),
(exports.LINE_ITEM_ID = "64134c5024ea4bdb1ee044b1"),
(exports.SERVER_URL = "https://api.lucien.ai"),
(exports.BD_NAME = "jeu-dev");